import { createSelector } from 'reselect';

const getProp = prop => params => params[prop];

const convertToNumber = string => (string ? parseInt(string, 10) : undefined);

const selectNumber = prop =>
    createSelector(
        getProp(prop),
        convertToNumber
    );

export const selectContentId = selectNumber('contentId');
export const selectNoteId = selectNumber('noteId');



// WEBPACK FOOTER //
// ./src/selectors/route_params.js